module.exports = __webpack_public_path__ + "static/national-2-web-medium-e891353ac61f2acfc98da1f875f6cc6b.woff2";